module.exports = __webpack_public_path__ + "static/media/event-06.535706a6.jpg";